import { FormControlLabel, Radio } from '@material-ui/core';
import { FormikRadioGroupField } from '@superdispatch/forms';
import { Stack, renderChildren } from '@superdispatch/ui';
import { TextBox } from '@superdispatch/ui-lab';
import { CarrierSettings } from 'shared/settings/CarrierSettingsAPI';
import {
  formatLoadBOLTemplate,
  LOAD_BOL_TEMPLATES,
} from '../data/LoadActionsDTO';

interface BolTemplateOptionLabelProps {
  title: string;
  description?: string;
}

function BolTemplateOptionLabel({
  title,
  description,
}: BolTemplateOptionLabelProps) {
  if (!description) {
    return renderChildren(title);
  }

  return (
    <>
      {title}
      <br />
      <TextBox color="secondary" variant="caption">
        {description}
      </TextBox>
    </>
  );
}

interface BolTemplateRadioGroupFieldProps {
  name: string;
  isCleanBolEnabled: boolean;
  applicableBolTemplates: CarrierSettings['bol_templates'];
  disabled?: boolean;
}

export function BolTemplateRadioGroupField({
  name,
  isCleanBolEnabled,
  applicableBolTemplates,
  disabled,
}: BolTemplateRadioGroupFieldProps) {
  return (
    <FormikRadioGroupField name={name} disabled={disabled}>
      <Stack space="xsmall">
        {isCleanBolEnabled
          ? applicableBolTemplates.map(({ key, title, description }) => (
              <FormControlLabel
                key={key}
                value={key}
                control={<Radio />}
                label={
                  <BolTemplateOptionLabel
                    title={title}
                    description={description}
                  />
                }
              />
            ))
          : LOAD_BOL_TEMPLATES.map((value) => (
              <FormControlLabel
                key={value}
                value={value}
                control={<Radio />}
                label={formatLoadBOLTemplate(value)}
              />
            ))}
      </Stack>
    </FormikRadioGroupField>
  );
}
